/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import Component from 'inferno-component';
import Button from 'components/shared/button/button';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/submit/submit_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});


/* ========== ~~~~~~~~~~ SUBMIT BUTTON : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Submit = (props) =>
    <button className={`${sheet.classes.submit} submit`} onClick={props.onSubmit} disabled={props.disabled} >{`Submit`} </button>




/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Submit;
